import Firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';

var config = require('../config/default.json');

const firebase = Firebase.initializeApp({
	apiKey: 'AIzaSyBiWuCCek5KjtueEFWUsMkI2AQsdVpI10k',
	authDomain: 'sales-centre-backend.firebaseapp.com',
	databaseURL: 'https://sales-centre-backend.firebaseio.com',
	projectId: 'sales-centre-backend',
	storageBucket: 'sales-centre-backend.appspot.com',
	messagingSenderId: '873145779548',
	appId: '1:873145779548:web:f3886b44d6d7a87722ad99',
	measurementId: 'G-KP83E0V1Y1',
});

// const firebase = Firebase.initializeApp(firebaseConfig);

export default firebase;
